module.exports = {
    content: [
		//'./**/*.php', // recursive search for *.php (be aware on every file change it will go even through /node_modules which can be slow, read doc)
		//'./src/styles/safelist.txt' // Use in case the inline "safelist" gets too long
		'./*.php',
		'./lib/**/*.php',
		'./templates/**/*.php',
		'./search-filter/**/*.php',
	],
	safelist: [
		'scroll-lock',
		'bg-green-dark',
		'bg-white',
		'text-white',
		'invert-0',
		'bg-white',
		'bg-green-dark',
		'after:bg-white',
		'after:bg-green-dark',
		'text-black',
		'invert',
		'fill-white',
		'fill-green-dark',
		'before:bg-green-dark',
		'after:bg-green-dark',
		'before:bg-white',
		'after:bg-white',
		'border-green-dark',
		'border-white',
		'border-black/20',
		'border-white/20',
		'[&_.logotxt_path]:fill-white',
		'[&_.logotxt_path]:fill-black',
		'col-start-4',
		'col-start-2',
		'col-start-3',
		'border-green-dark',
		'border-white',
		'grid-cols-2',
		'grid-cols-3',
		'grid-cols-4',
		'maxxl:bg-green-dark',
		'maxxl:bg-white',
		'maxxl:bg-green',
		'maxxl:bg-black',
		'maxxl:[&_.bgsubmenu]:!bg-green-dark',
		'maxxl:[&_.bgsubmenu]:!bg-white',
		'maxxl:[&_.bgsubmenu]:!text-white',
		'maxxl:[&_.bgsubmenu]:!text-black',
		
	],
    theme: {
        colors: {
            'transparent': 'transparent',
            'white': '#FFF',
            'black': '#000',
			'green': {
                light: '#9ECFD1',
                DEFAULT: '#2B6264',
                dark: '#143840',
            },
			'orange': '#E91F0D',
			'grey': '#D9D9D9'
        },
         fontFamily: {
            Epilogue: ['Epilogue', 'sans-serif'],
        }, 
        /* fontSize: {
            '30': ['30px'],
            '48': ['48px'],
        }, */
		/* lineHeight: {
            '30': '30px',
            '40': '40px',
        }, */
		/* letterSpacing: {
            tighter: '-0.5px',
            tight: '-0.25px',
            normal: 'normal',
            wide: '-0.1px',
            wider: '-0.07px',
            widest: '1px',
        }, */
		borderRadius: {
			'none': '0px',
			2: '2px',
			4: '4px',
			5: '5px',
			6: '6px',
			8: '8px',
			10: '10px',
			12: '12px',
			14: '14px',
			15: '15px',
			20: '20px',
			25: '25px',
			30: '30px',
			35: '35px',
			40: '40px',
			45: '45px',
			50: '50px',
			full: '9999px',
		},
		
        container: {
			center: true,
			padding: {
				// Need to assign all of the screen sizes or the container-break-out plugin won't work
				DEFAULT: '30px',
				xs: '40px',
				sm: '40px',
				md: '40px',
				lg: '40px',
				xl: '40px',
				'2xl': '40px',
			},
			screens: {
				xs: '340px',
				sm: '576px',
				md: '768px',
				lg: '1024px',
				xl: '1280px',
				'2xl': '1536px',
			},
		},
		screens: {
			xs: '340px',
			sm: '576px',
			md: '768px',
			lg: '1024px',
			xl: '1280px',
			'2xl': '1536px',
			letter: { raw: "(max-height: 820px) and (min-width: 1024px)" },
			maxlg: { raw: "(max-width: 1023px)" },
			maxxl: { raw: "(max-width: 1279px)" },
			
		},
        extend: {
			backgroundImage: {
                'orange-arrow': "url('/wp-content/themes/finbourne/assets/img/icons/orange-arrow.svg')",
				'link-arrow': "url('/wp-content/themes/finbourne/assets/img/icons/arrow-link.svg')",
				'link-arrow-orange': "url('/wp-content/themes/finbourne/assets/img/icons/arrow-link-orange.svg')",
				'testimonial': "url('/wp-content/themes/finbourne/assets/img/icons/testimonial.svg')",
				'x': "url('/wp-content/themes/finbourne/assets/img/icons/x.svg')",
				'list': "url('/wp-content/themes/finbourne/assets/img/icons/list.svg')",
				'play-icon': "url('/wp-content/themes/finbourne/assets/img/icons/play-icon.svg')",
				'close-icon': "url('/wp-content/themes/finbourne/assets/img/icons/close-icon.svg')",
				'testimonial-orange': "url('/wp-content/themes/finbourne/assets/img/icons/testimonial-orange.svg')",
				'location': "url('/wp-content/themes/finbourne/assets/img/icons/location.svg')",
				'date': "url('/wp-content/themes/finbourne/assets/img/icons/date.svg')",
				'tick': "url('/wp-content/themes/finbourne/assets/img/icons/tick.svg')",
				'prev': "url('/wp-content/themes/finbourne/assets/img/icons/prev.svg')",
				'prevwhite': "url('/wp-content/themes/finbourne/assets/img/icons/prevwhite.svg')",
				'thanks': "url('/wp-content/themes/finbourne/assets/img/form_confirmation.svg')",
				'svgbutton': "url('/wp-content/themes/finbourne/assets/img/icons/svg_button.svg')",
				'svgbutton-green': "url('/wp-content/themes/finbourne/assets/img/icons/svg_button_green.svg')",
				'plus': "url('/wp-content/themes/finbourne/assets/img/icons/plus.svg')",
				'minus': "url('/wp-content/themes/finbourne/assets/img/icons/minus.svg')",
				
				
			},
			container: {
				screens: {
					xs: {
						max: 'none', // Remove the max-width: 340px from the xs breakpoint
					},
				},
			},
            typography: (theme) => ({
                DEFAULT: {
                    css: {
                        '*': {
                            '&:first-child': {
                                marginTop: 0,
                            },
                            '&:last-child:not(img):not(picture)': {
                                marginBottom: 0,
                            },
                            '&:last-child:not(img):not(picture) img': {
                                marginBottom: 0,
                            }
                        },
                    },
                },
            }),
			debugScreens: {
				position: ['top', 'right'],
			},
        }
    },
    plugins: [
        function ({ addVariant }) {
			addVariant('letterbox', '@media (max-height: 750px) and (min-width: 900px)');
            addVariant("children", "& > *");
            addVariant("children-all", "& *");
            //addVariant("next-peer-hover", ".peer:hover + &");
            //addVariant("item-active", "&[data-active=true]");
            //addVariant("item-active-children", "&[data-active=true] > *");
			addVariant('first', '&:nth-child(1)')
			addVariant('second', '&:nth-child(2)')
			addVariant('third', '&:nth-child(3)')
			addVariant('fourth', '&:nth-child(4)')
			addVariant('fifth', '&:nth-child(5)')
			addVariant('sixth', '&:nth-child(6)')
        },
		
        require('@tailwindcss/typography'),
		require('@tailwindcss/forms'),
		require('tailwindcss-debug-screens'),
		require('tailwind-container-break-out')
    ],
}